import { render, staticRenderFns } from "./DpeContactInfo.vue?vue&type=template&id=1ecca6b7&scoped=true"
import script from "./DpeContactInfo.vue?vue&type=script&lang=js"
export * from "./DpeContactInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecca6b7",
  null
  
)

export default component.exports